import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetUsersListing({ commit }, list) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/user/list?order_by=${list.order_by || 'created_on'}&order_dir=${list.order_dir || 'desc'}`,
        params: {
          page: list.page ? list.page : '',
          per_page: list.per_page ? list.per_page : '',
          user_name: list.full_name ? `*${list.full_name}*` : '',
          status: list.is_active ? "active" : '',
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err);
      });
    });
  },

  ChangeUserStatusListing({ commit }, user) {
    console.log(user)
    return new Promise((resolve, reject) => {
      axios({
        url: "/user/" + user.user_id,
        data: { is_active: user.is_active },
        method: "PATCH"
      }).then(res => {
        console.log(res)
        resolve(res.data.payload);
      })
        .catch(err => {
          reject(err);
        });
    });
  },



  GetUsers({ commit }, list) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/user/list?order_by=created_on&order_dir=desc",
        params: {
          page: list.page ? list.page : "",
          per_page: list.per_page ? list.per_page : "",
          user_name: list.user_name ? "*" + list.user_name + "*" : "",
          company_name: list.company ? "*" + list.company + "*" : "",
          company_uuid: list.companyId ? list.companyId : "",
          order_by: list.order_by,
          order_dir: list.order_dir,
          is_active: list.is_active ? true : '',
          is_admin:list.is_admin=='user' ? false : list.is_admin=='admin' ? true : ''
          
        },
        method: "GET",
      })
        .then((res) => {
          resolve(res.data.payload);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  GetUser({ commit }, list) {
    return new Promise((resolve) => {
      axios({
        url: "/user/" + list.id,
        params: {
          page: list.page,
          search: list.search,
        },
        method: "GET",
      }).then((res) => {
        resolve(res.data.payload);
      });
    });
  },

  AddUser({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/user",
        data: user.user,
        method: "POST",
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  EditUser({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/user/" + user.id,
        data: user.contact,
        method: "PATCH",
      })
        .then((res) => {
          resolve(res.data.payload);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  ChangeUserStatus({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/user/" + user.user.userId,
        data: user.user,
        method: "PATCH",
      })
        .then((res) => {
          resolve(res.data.payload);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  DeleteUser({ commit }, userId) {
    console.log("user->>>>", userId);
    return new Promise((resolve, reject) => {
      axios({
        url: "/user/" + userId,
        data: userId,
        method: "DELETE",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

// mutations
const mutations = {};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
